import { render, staticRenderFns } from "./ServiceOrderTop5Category.vue?vue&type=template&id=749428fe&scoped=true&"
import script from "./ServiceOrderTop5Category.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderTop5Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749428fe",
  null
  
)

export default component.exports